import React from 'react';
import { func, string, object, bool } from 'prop-types';
import withColor from 'util/hoc/with-color';
import {
  Input,
  InputLabel,
  InputWrapper,
} from 'apps/journey/components/input-field/styled-input-field';

class InputField extends React.Component {
  static propTypes = {
    name: string,
    label: string,
    ariaLabel: string,
    value: string,
    onChange: func,
    onKeyDown: func,
    colors: object,
    ignoreState: bool,
    ariaAutocomplete: string,
    ariaActiveDescendant: string,
    ariaControls: string,
  };

  state = {
    focus: false,
    value: '',
    labelRef: null,
  };

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  handleChange = (e) => {
    const { onChange, ignoreState } = this.props;
    if (!ignoreState) {
      this.setState({
        value: e.target.value,
      });
    }
    if (onChange) onChange(e);
  };

  setFocus = () => {
    this.inputRef.current.focus();
  };

  render() {
    const {
      component: Component = InputWrapper,
      name,
      label,
      ariaLabel,
      ariaAutocomplete,
      ariaActiveDescendant,
      ariaControls,
      value,
      colors,
      onChange,
      onKeyDown,
      ...props
    } = this.props;

    const tValue = this.state.value || value || props.defaultValue || '';

    return (
      <Component>
        <Input
          aria-label={ariaLabel || label}
          aria-autocomplete={ariaAutocomplete}
          aria-activedescendant={ariaActiveDescendant}
          aria-controls={ariaControls}
          id={name}
          name={name}
          onFocus={() => this.setState({ focus: true })}
          onBlur={() => this.setState({ focus: false })}
          value={tValue}
          onChange={this.handleChange}
          onKeyDown={onKeyDown}
          active={this.state.focus || tValue}
          borderColor={colors.tertiary}
          invalidColor={colors.auxilary_5}
          ref={this.inputRef}
          type="text"
          labelHeight={this.labelRef?.clientHeight}
          {...props}
        />
        <InputLabel
          ref={(ref) => {
            this.labelRef = ref;
            !this.state.labelRef && this.setState({ labelRef: ref });
          }}
          activeColor={colors.tertiary}
          active={this.state.focus || tValue}
          onClick={this.setFocus}
          htmlFor={name}
        >
          {label}
        </InputLabel>
      </Component>
    );
  }
}

export default withColor(InputField);
